import { connect } from 'react-redux';
import EmailEntry from 'components/EmailEntry';
import { addToWaitingList, emailChanged } from '../actions';

const mapStateToProps = ({ scene }) => {
  return {
    email: scene.landingFlow.email,
    loading: scene.landingFlow.loading,
    error: scene.landingFlow.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleSubmit: (email) => { dispatch(addToWaitingList(email)) },
    onEmailChange: (value) => { dispatch(emailChanged(value)) }
  }
}

const EmailEntryContainer = connect(mapStateToProps, mapDispatchToProps)(EmailEntry)
export default EmailEntryContainer;



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/components/EmailEntryContainer.js